import { supabase } from "../utils/supabaseClient";
import { shouldShowOnCorporateEnrollForm } from "./corporateEnrollHelpers";

export async function fetchTemplateFieldMeta(templateId) {
    if (!templateId) return { ids: null, records: [] };
    const { data: rt, error } = await supabase
        .from("registration_templates")
        .select("field_ids")
        .eq("id", templateId)
        .single();
    if (error || !rt?.field_ids?.length) return { ids: null, records: [] };
    const ordered = [...rt.field_ids].sort(
        (a, b) => (Number(a.display_order) || 0) - (Number(b.display_order) || 0),
    );
    const ids = ordered.map((x) => x.field_id).filter(Boolean);
    if (ids.length === 0) return { ids: null, records: [] };
    const { data: fields, error: fe } = await supabase
        .from("additional_registration_fields")
        .select("*")
        .in("id", ids);
    if (fe) return { ids, records: [] };
    const byId = new Map((fields || []).map((f) => [f.id, f]));
    const records = ids
        .map((id) => byId.get(id))
        .filter(Boolean)
        .filter(shouldShowOnCorporateEnrollForm);
    const filteredIds = records.map((r) => r.id);
    return { ids: filteredIds, records };
}
